import appBustype from "../../views/appSettings/bustype.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("bustype", {
    url: "bustype/:id",
    parent: "app",
    views: {
      view: {
        template: appBustype,
      },
    },
    reloadOnSearch: false,
    data: { title: "Bustype" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/bustype/bustype.urls.js